export const MIN_SHELFIE_PICKED_ITEMS = 5
export const MAX_SHELFIE_PICKED_ITEMS = 8
